import ChatbotModel from './ChatbotModel';

export enum BusinessUseCase {
  MessengerAdvertising = 'advertising',
  WebsiteChatWidget = 'website_chat',
  RSSFeed = 'rss',
  ECommerce = 'e_commerce',
  CustomerSupport = 'support',
  NewslettersSubscriptions = 'newsletters',
  Surveys = 'surveys',
  ChatBlasting = 'blasting',
  AppointmentSettings = 'appointments',
  LeadGenerationQualification = 'lead_generation',
}

type CompanyLogoUrls = {
  small: string;
  medium: string;
  large: string;
  original: string;
};

export type CompanyLogo = {
  id: number;
  uploadUrl: string;
  urls: CompanyLogoUrls;
};

export type CompanyLevelFeatureFlag =
  | 'twilio'
  | 'new_sign_up_flow'
  | 'show_cues'
  | 'instachamp'
  | 'sms_contact_uploads'
  | 'november2021Pricing'
  | 'chat_widget_convo_continue_options'
  | 'live_comment'
  | 'public_reply'
  | 'automations'
  | 'getemails'
  | 'onboarding2022'
  | 'xx_google_oauth_verification';

export enum JobRole {
  ownBusiness = 'Business Owner',
  marketing = 'Marketing',
  creator = 'Creator or Coach',
  agency = 'Agency Marketer',
  sales = 'Sales',
}

export enum EmployeeCount {
  optionOne = '1-2 employees',
  optionTwo = '3-14 employees',
  optionThree = '15-149 employees',
  optionFour = '150+ employees',
}

export enum Industry {
  advertising = 'Marketing / Advertising',
  eCommerce = 'Retail / Ecommerce',
  education = 'Education',
  financial = 'Finance',
  insurance = 'Insurance',
  recruitment = 'Jobs',
  legal = 'Legal',
  nonprofit = 'Nonprofit',
  realEstate = 'Real Estate',
  rehab = 'Rehab',
  software = 'Software',
  travel = 'Travel / Tourism',
  other = 'Other',
}

export enum OnboardingGoal {
  appointmentBooking = 'Appointment Booking',
  outboundLeadGen = 'Outbound Lead Generation',
  automateSocialPlatformSales = 'Social Media & Website Sales Automation',
  automateLeadQualification = 'Automate Lead Qualification of a Pre-Existing Lead List',
  marketingFunnelOptimization = 'Funnel Optimization',
  findInfluencers = 'Find Influencers',
}

export enum AdsSpend {
  optionOne = '$0/month',
  optionTwo = '$1-999/month',
  optionThree = '$1,000+/month',
}

export enum ClientsCharge {
  optionOne = '$1-$249',
  optionTwo = '$250-$3999',
  optionThree = '$4000+',
}

export enum WebsiteTraffic {
  optionOne = '0-499 visitors',
  optionTwo = '500-4,999 visitors',
  optionThree = '5,000+ visitors',
}

export enum LeadsList {
  optionOne = '1-999 contacts',
  optionTwo = '1,000-4,999 contacts',
  optionThree = '5,000+ contacts',
}

export default interface CompanyModel {
  id: number;
  name: string;
  bots: ChatbotModel[];
  agencyId?: string;
  createdAt: string;
  kind: string;
  freePricePlan: boolean;
  teamPricePlan: boolean;
  activePromoCode: boolean;
  editable: boolean;
  matchesQualifiedCountries: boolean;
  businessEmail?: string;
  phoneNumber?: string | null;
  website?: string;
  fbAdvertisingSpend?: any;
  businessUseCases?: BusinessUseCase[];
  assetId?: number | null;
  logo?: CompanyLogo;
  subdomain?: string | null;
  referrer?: string;
  inviteToken?: string;
  additionalFeatures?: CompanyLevelFeatureFlag[];
  crm?: string;
  employeeCount?: string;
  clientsCharge?: string;
  websiteVisitors?: string;
  leadsList?: string;
  consideredDemo: boolean;
  jobRole: JobRole | string;
  persona: 'smb' | 'marketer' | 'agency';
  monthlyAdBudget: string;
  experience: string;
  goal: string;
  industry: string;
  clientsCount: string;
  businessFirstName: string;
  businessLastName: string;
  businessName: string;
}
